import { useTheme } from '@mui/material';
import { SVGProps } from 'react';

export const NotificationIcon = ({
  stroke,
  strokeOpacity,
  ...props
}: SVGProps<SVGSVGElement>) => {
  const theme = useTheme();
  const strokeColor = stroke || theme.palette.action.active;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      style={{ display: 'block' }}
      {...props}
    >
      <path
        stroke={strokeColor}
        strokeLinecap="round"
        strokeOpacity={strokeOpacity ?? 0.54}
        strokeWidth={1.5}
        transform="translate(1.95 2.03)"
        d="M5.25 15.106v-7.5a5.1 5.1 0 0 1 10.2 0v7.5m-13.5 0h16.8m-11.4 3.6h6m-12-11.1a8.972 8.972 0 0 1 2.636-6.364"
      />
    </svg>
  );
};
